module.exports = "/_next/static/images/PersonalizedCustomerEngagement@2x-dfe0bc456a509a179287ec19fa6c1627.webp";